import React from 'react'
import HomeAboutsec from './home-section/HomeAboutsec';
import SlideSec from './home-section/SlideSec';
// import WhyChoose from './home-section/WhyChoose';
// import OurValue from './home-section/OurValue';
// import WhatdoWeOffer from './home-section/WhatdoWeOffer';


export default function HomePage() {
  return (
    <div>
    {/* <NavBar/>  */}
    <SlideSec/>
    <HomeAboutsec/>
    {/* <WhyChoose/>
    <OurValue/>
    <WhatdoWeOffer/> */}
    
    </div>
  )
}
